import {closeModal, openModal, url} from "../../../utilities";
import Spinner from "../../../spinner";
import {toastAlert} from "../../../toastAlert";
import axios from "axios";
import * as Constants from "../constants";

export const users_and_entities = (entities, entitiesDataUpdated) => {
    const body = $('body');

    const form = $('#addInvoice, #editInvoice');
    const entityModal = $("#chooseEntityModal");
    const entityPriceListModal = $("#entityPriceListModal");

    // Guest member
    function setupGuest() {
        let guestSet = false;

        let first_name = '';
        let last_name = '';

        $("#addGuest input").each(function () {
            let name = $(this).attr('name');
            let value = $(this).val();

            $(`input[name="${name}"]`).val(value);

            if (name === 'guest_first_name') {
                first_name = value;
            } else if (name === 'guest_last_name') {
                last_name = value;
            }

            if (value !== '') {
                guestSet = true;
            }
        })

        if (guestSet) {
            $('#btnAddGuest').text('Edytuj osobę spoza koła');

            let select = form.find('select[name="user_id"]');
            let option = select.find('option[value="0"]');

            if (option.length === 0) {
                select.append(`<option value="0">${first_name} ${last_name}</option>`)
                select.val(0).change();
            } else {
                option.text(`${first_name} ${last_name}`);
            }
        } else {
            $('#btnAddGuest').text('Dodaj osobę spoza koła');
        }
    }

    setupGuest();

    $("#btnSaveGuest").click(function () {
        setupGuest();
        closeModal('#addGuest');
    })

    // Entities table
    let entitiesTable = $('#entitiesTable').DataTable({
        stateSave: false,
        columnDefs: [
            {
                targets: Constants.ENTITIES_NAME_INDEX,
                data: 'name'
            },
            {
                targets: Constants.ENTITIES_ADDRESS_INDEX,
                data: 'address'
            },
            {
                targets: Constants.ENTITIES_ACTION_INDEX,
                data: null,
                render: (data, type, row) => {
                    let disabled = false;
                    let user_id = form.find('select[name="user_id"]').val();
                    if(user_id.startsWith('entity-')) {
                        let id = user_id.replace('entity-', '');
                        if(parseInt(id) === parseInt(row.id)) {
                            disabled = true;
                        }
                    }

                    return `
                        <button class="btn btn-sm btn-primary btnEntityPriceList mb-1" data-id="${row.id}">
                            Podgląd cennika
                        </button>
                        <a class="btn btn-sm btn-primary mb-1 btnEditEntity" target="_blank" href="${url(`app/reckonings/business-entities/${row.id}/edit`)}">
                            Edytuj
                        </a>
                        <button class="btn btn-sm btn-primary btnChooseEntity mb-1" data-id="${row.id}" ${disabled && 'disabled'}>
                            Wybierz
                        </button>
                    `;
                }
            }
        ]
    });
    let entityPriceListTable = $('#entityPriceListTable').DataTable({
        stateSave: false,
        columnDefs: [
            {
                targets: Constants.ENTITY_PRICE_LIST_NAME_INDEX,
                data: null,
                render: (data, type, row) => {
                    return row.animal_type.name;
                }
            },
            {
                targets: Constants.ENTITY_PRICE_LIST_PRICE_1_CLASS_INDEX,
                data: 'price_1_class'
            },
            {
                targets: Constants.ENTITY_PRICE_LIST_PRICE_2_CLASS_INDEX,
                data: 'price_2_class'
            },
            {
                targets: Constants.ENTITY_PRICE_LIST_FLAT_RATE_INDEX,
                data: 'flat_rate'
            },
        ]
    });

    let entityModalOpened = false;
    entityModal.on('shown.bs.modal', () => {
        entityModalOpened = true;
    }).on('hidden.bs.modal', () => {
        entityModalOpened = false;
    })

    document.addEventListener("visibilitychange", async function () {
        if (document.visibilityState === 'visible' && entityModalOpened) {
            await loadEntitiesFromServer();
        }
    });

    body.on('click', '.btnChooseEntity', function () {
        let id = $(this).data('id');
        let entity = entities.data.find(el => parseInt(el.id) === parseInt(id));

        if(!entity) {
            return;
        }

        let value = `entity-${entity.id}`;
        let select = form.find('select[name="user_id"]');
        let option = select.find(`option[value="${value}"]`);

        if(option.length === 0) {
            option = $(`<option data-entity="true" value="${value}">${entity.name}</option>`);
            select.append(option).val(value).change();
        } else {
            select.val(value).change();
        }

        closeModal(entityModal);
    })

    form.find('select[name="user_id"]').change(function() {
        let value = $(this).val();
        entitiesTable.$(`.btnChooseEntity`).attr('disabled', false);
        if(value.startsWith('entity-')) {
            let id = value.replace('entity-', '');
            entitiesTable.$(`.btnChooseEntity[data-id="${id}"]`).attr('disabled', true);

            let entity = entities.data.find(el => parseInt(el.id) === parseInt(id));
            if(entity) {
                entities.current = entity;
            }
        } else {
            entities.current = null;
        }
    })

    body.on('click', '.btnEntityPriceList', function () {
        let id = $(this).data('id');
        let entity = entities.data.find(el => parseInt(el.id) === parseInt(id));

        if (!entity) {
            return;
        }

        entityPriceListTable.api().clear().rows.add(entity.be_prices ?? []).draw();

        openModal(entityPriceListModal);
    })

    const reloadEntitiesTable = () => {
        entitiesTable.api().clear().rows.add(entities.data).draw();
    }
    reloadEntitiesTable();

    const loadEntitiesFromServer = async () => {
        let spinner = new Spinner();
        try {
            let response = await axios.get(url('api/reckonings/business-entities'));
            if (response.status !== 200) {
                throw new Error();
            }

            entities.data = response.data.entities;
            if(entities.current !== null) {
                entities.current = entities.data.find(el => parseInt(el.id) === parseInt(entities.current.id));
            }
            try {
                reloadEntitiesTable();
                entitiesDataUpdated();
            } catch(err) {}
            spinner.destroy();
        } catch (err) {
            spinner.destroy();
            closeModal(entityModal);
            toastAlert('Wystąpił błąd podczas ładowania dostępnych podmiotów. Spróbuj ponownie później', {type: 'danger'})
        }
    }

    $("#btnOpenEntityModal").click(async function () {
        if (entities.data.length === 0) {
            await loadEntitiesFromServer();
        }
    })

    $("#btnRefreshEntities").click(async function () {
        await loadEntitiesFromServer();
    })
}
